import axios from "axios";
import { z } from "zod";
import { errorLog } from "../../../logger";
import { PaginationMetadata, } from "../../Types";
import ValidationError from "../../ZodError";
import { TaskActivity } from "../Types";
import { taskActivityUrl } from "./urls";
const GetTaskActivityResponse = z.object({
    data: TaskActivity.array(),
    pagination: PaginationMetadata,
});
export const orderByParams = ["timestamp asc", "timestamp desc"];
export default async function getTaskActivity(taskId, config, queryParams) {
    const { data } = await axios.get(taskActivityUrl(taskId), {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            Advisor: config.advisorId,
            version: "20250221",
        },
        params: queryParams,
    });
    const decoded = GetTaskActivityResponse.safeParse(data);
    if (decoded.success) {
        return {
            data: decoded.data.data,
            pagination: decoded.data.pagination,
        };
    }
    else {
        const errorMessage = "[getTaskActivities] returned unexpected data.";
        errorLog(getTaskActivity.name, JSON.stringify(decoded.error.issues));
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=getTaskActivity.js.map